import React from "react";
import { Dialog } from "@headlessui/react";
import { IKImage } from "imagekitio-react";
import { useState } from "react";
import CountryCode25 from "./CountryCode25";
import {
  getXanoAuthEmailToken,
  sendOtp,
  verifyOtp,
  resendOtp,
  resetPassword,
  logout,
  sendOtpFromEmail,
  getXanoAuthToken,
  requestOtp,
  validatePasswordResetAccess,
  updatePassword,
  requestResendOtp,
  setOnboardingPhase,
} from "../../redux/actions/authentication";
import { toast } from "react-toastify";
import { axiosAuth } from "../../config/axiosInstances";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { Mixpanel } from "../../config/Mixpanel";
import ReactPixel from "react-facebook-pixel";
import Constants from "../../common/constants";
import { useCookies } from "react-cookie";
import GoogleLogin from "react-google-login";
import { XANO_GOOGLE_CLIENT_ID } from "../../config/api_config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { PhoneNumberUtil } from "google-libphonenumber";
import { useSearchParams } from "react-router-dom";
import { setActivationPhase } from "../../redux/actions/contentPayer";
import { SET_IS_ACTIVATION } from "../../redux/actions/types";
import { fetchIsUserFromBetaProduct } from "../../redux/actions/personaliseCourse";
import LoginLogo from "../../components/Navbar/NavBarRight/LoginLogo";
import { countryPhoneCodes } from "../LandingPage/countryPhoneCode";
import NewLogo from "../../components/CNLogo/NewLogo";

const PasswordResetModal = ({ isModalEnabled, setIsModalEnabled }) => {
  const [emailFormData, setEmailFormData] = useState({
    email: "",
    password: "",
  });
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isEmailFormEnabled, setIsEmailFormEnabled] = useState(false);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [userJWT, setUserJWT] = useState(null);
  const [mobile, setMobile] = useState("");
  const [OTP, setOTP] = useState("");
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [isResendOtp, setIsResendOtp] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(
    countryPhoneCodes.find((el) => el?.name === "India")
  );
  const [passwords, setPasswords] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const [isVerifyOtpLoading, setIsVerifyOtpLoading] = useState(false);
  const [isSendOtpLoading, setIsSendOtpLoading] = useState(false);
  const [isLoginLoading, setIsLoginLoading] = useState(false);
  const [isResetLoading, setIsResetLoading] = useState(false);
  const [isGoogleLoading, setIsGoogleLoading] = useState(false);
  const [cookies, setCookie, removeCookie] = useCookies();
  const [isVisible, setIsVisible] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const phoneUtil = PhoneNumberUtil.getInstance();
  const regex = /^\d+$/;
  const [authToken, setAuthToken] = useState("");
  const [originalPhoneNumber, setOriginalPhoneNumber] = useState("");
  const [originalEmail, setOriginalEmail] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();

  console.log("country", userJWT);
  const onSubmit = () => {
    // console.log(email);
    setIsSendOtpLoading(true);
    setOriginalEmail(email);
    setOriginalPhoneNumber(selectedCountry?.dial_code + phoneNumber);
    if (email?.length > 0) {
      dispatch(
        requestOtp(
          email,
          "",
          "email",
          (successObj) => {
            if (successObj?.result === "success") {
              //console.log(response.data.jwt);
              setIsOtpSent(true);
              toast.success(successObj?.message, {
                closeButton: false,
              });
              setUserJWT(successObj?.data?.jwt);
              setPhoneNumber(successObj?.data?.phone_number);
              //successCallback(response);
            } else {
              toast.error(successObj?.message);
              setIsSendOtpLoading(false);
            }
          },
          (errorObj) => {
            toast.error("Enter Valid Email");
            setIsSendOtpLoading(false);
          }
        )
      );
    } else {
      if (
        (selectedCountry?.dial_code + phoneNumber)[0] === "+" &&
        regex.test((selectedCountry?.dial_code + phoneNumber).slice(1))
      ) {
        if (
          !phoneUtil.isValidNumberForRegion(
            phoneUtil.parse(phoneNumber, selectedCountry?.code),
            selectedCountry?.code
          )
        ) {
          toast.error("Enter Valid Phone Number");
          setIsSendOtpLoading(false);
          return;
        } else {
          dispatch(
            requestOtp(
              "",
              selectedCountry?.dial_code + phoneNumber,
              "phone_number",
              (successObj) => {
                if (successObj?.result === "success") {
                  //console.log(response.data.jwt);
                  setIsOtpSent(true);
                  toast.success(successObj?.message, {
                    closeButton: false,
                  });
                  setUserJWT(successObj?.data?.jwt);
                  setPhoneNumber(successObj?.data?.phone_number);
                  //successCallback(response);
                } else {
                  toast.error(successObj?.message);
                  setIsSendOtpLoading(false);
                }
              },
              (errorObj) => {
                toast.error("Enter Valid Email");
                setIsSendOtpLoading(false);
              }
            )
          );
        }
      } else {
        toast.error("Enter Valid Phone Number");
        setIsSendOtpLoading(false);
        return;
      }
    }
  };
  console.log({ isEmailFormEnabled: isEmailFormEnabled });
  const verifyOTP = () => {
    setIsVerifyOtpLoading(true);
    dispatch(
      validatePasswordResetAccess(userJWT, OTP, (successObj) => {
        //console.log(successObj);
        if (successObj?.result === "success") {
          console.log("it ran");
          setIsOtpVerified(true);
          setAuthToken(successObj?.data?.authToken);
          setEmail(successObj?.data?.email);
          ReactPixel.trackSingle("333999584825866", "Lead");
        } else {
          toast.error(successObj?.message, {
            closeButton: false,
          });
          setIsVerifyOtpLoading(false);
        }
      })
    );
  };

  const resendOTP = (type) => {
    if (originalEmail?.length > 0) {
      dispatch(
        requestResendOtp(
          originalEmail,
          "",
          "email",
          type,
          (successObj) => {
            //console.log(success);
            if (successObj?.result === "success") {
              //console.log(response.data.jwt);
              setIsOtpSent(true);
              toast.success(successObj?.message, {
                closeButton: false,
              });
              setPhoneNumber(successObj?.data?.phone_number);
              //successCallback(response);
            } else {
              toast.error(successObj?.message);
              setIsSendOtpLoading(false);
            }
          },
          (errorObj) => {
            toast.error("Enter Valid Email");
            setIsSendOtpLoading(false);
          }
        )
      );
    } else {
      dispatch(
        requestResendOtp(
          "",
          originalPhoneNumber,
          "phone_number",
          type,
          (successObj) => {
            //console.log(success);
            if (successObj?.result === "success") {
              //console.log(response.data.jwt);
              setIsOtpSent(true);
              toast.success(successObj?.message, {
                closeButton: false,
              });
              setPhoneNumber(successObj?.data?.phone_number);
              //successCallback(response);
            } else {
              toast.error(successObj?.message);
              setIsSendOtpLoading(false);
            }
          },
          (errorObj) => {
            toast.error("Enter Valid Phone Number");
            setIsSendOtpLoading(false);
          }
        )
      );
    }
  };

  function logoutHandler() {
    dispatch(logout());
    removeCookie("authToken", { path: "/" });
    navigate("/");
  }

  const onResetPassword = () => {
    setIsResetLoading(true);
    if (passwords.newPassword !== passwords.confirmPassword) {
      toast.error("Passwords do not Match");
      setIsResetLoading(false);
    } else if (passwords.newPassword.length < 8) {
      toast.error("Minimum 8 characters Required!!");
      setIsResetLoading(false);
    } else {
      dispatch(
        updatePassword(authToken, passwords.newPassword, (successObj) => {
          //console.log(successObj);
          setIsModalEnabled(false);
          toast.success(`Password Changed, Login Again`, {
            closeButton: false,
          });

          logoutHandler();
        })
      );
    }
  };

  if (isOtpVerified === true) {
    return (
      <Dialog
        open={isModalEnabled}
        onClose={() => setIsModalEnabled(!isModalEnabled)}
        as="div"
        style={{ zIndex: "9999" }}
        className="fixed inset-0 z-40 mx-auto my-auto flex flex-col text-white"
      >
        <Dialog.Overlay className="fixed inset-0 z-10 my-auto bg-black/60 backdrop-blur-[10px]" />
        <Dialog.Title />
        <Dialog.Description />
        <div
          className="bg-glass-effect relative z-[80] m-auto  w-[90%] max-w-xl rounded-[16px] p-[1px]"
          style={{
            backgroundImage: `linear-gradient(
to right,
rgba(255, 255, 255, 0.3) 0%,
rgba(255, 255, 255, 1) 50%,
rgba(255, 255, 255, 0.3) 100%
)`,
          }}
        >
          <div
            className="flex flex-col items-center justify-center rounded-[16px] bg-[#012A4A] p-3"
            style={{
              backgroundImage:
                "radial-gradient(circle at center, rgba(0,0,0,0) 0%, rgba(0,0,0,0.7) 100%)",
              boxShadow: "0px 0px 20px 0px #0000004D",
            }}
          >
            <NewLogo />
            <div className="flex w-full flex-col items-center justify-center">
              <div className="mt-4 flex w-full flex-col self-start leading-tight">
                <h1 className="text-[20px] font-semibold text-white">
                  Reset Password
                </h1>
                <div className="text-[14px] font-medium text-gray-300">
                  Email: {email}
                </div>
                <div className="mt-4 flex flex-col">
                  <label
                    htmlFor="password"
                    className="text-[14px] font-medium text-white"
                  >
                    New Password
                  </label>
                  <div className="mt-1 flex h-[44px] w-full ">
                    <input
                      id="newpassword"
                      name="password"
                      type={isVisible ? "text" : "password"}
                      onChange={(event) =>
                        setPasswords({
                          ...passwords,
                          newPassword: event.target.value,
                        })
                      }
                      required
                      className="h-12 w-full appearance-none rounded-l-lg border-none bg-[#07274b] text-white placeholder-gray-500 focus:z-10 focus:border-[#7FC241] focus:outline-none focus:ring-[#7FC241] sm:text-sm"
                    />
                    <div
                      className="h-12 cursor-pointer rounded-tr-lg rounded-br-lg bg-[#07274b] p-3.5 text-[#7FC241]"
                      onClick={(e) => setIsVisible(!isVisible)}
                    >
                      <FontAwesomeIcon
                        icon={isVisible ? faEyeSlash : faEye}
                        className=""
                      />
                    </div>
                  </div>
                </div>
                <div className="mt-4 flex flex-col ">
                  <label
                    htmlFor="password"
                    className="text-[14px] font-medium text-white"
                  >
                    Confirm New Password
                  </label>
                  <input
                    id="confirmpassword"
                    name="password"
                    type="password"
                    onChange={(event) =>
                      setPasswords({
                        ...passwords,
                        confirmPassword: event.target.value,
                      })
                    }
                    required
                    className="h-12 w-full appearance-none   rounded-lg border-none bg-[#07274b] text-white placeholder-gray-500 focus:z-10 focus:border-[#7FC241] focus:outline-none focus:ring-[#7FC241] sm:text-sm"
                  />
                </div>
              </div>
              <button
                disabled={
                  isResetLoading ||
                  passwords.newPassword?.length === 0 ||
                  passwords.confirmPassword?.length === 0
                }
                className="mt-4 h-12 w-full rounded-lg bg-[#7FC241] text-center text-[16px] font-semibold text-[#121212] disabled:opacity-50"
                onClick={(event) => onResetPassword()}
              >
                {isResetLoading ? "Updating Password..." : "Reset Password"}
              </button>
            </div>
          </div>
        </div>
      </Dialog>
    );
  } else if (isOtpSent === true) {
    return (
      <Dialog
        open={isModalEnabled}
        onClose={() => setIsModalEnabled(!isModalEnabled)}
        as="div"
        style={{ zIndex: "9999" }}
        className="fixed inset-0 z-40 mx-auto my-auto flex flex-col text-white"
      >
        <Dialog.Overlay className="fixed inset-0 z-10 my-auto bg-black/60 backdrop-blur-[10px]" />
        <Dialog.Title />
        <Dialog.Description />
        <div
          className="bg-glass-effect relative z-[80] m-auto  w-[90%] max-w-xl rounded-[16px] p-[1px]"
          style={{
            backgroundImage: `linear-gradient(
to right,
rgba(255, 255, 255, 0.3) 0%,
rgba(255, 255, 255, 1) 50%,
rgba(255, 255, 255, 0.3) 100%
)`,
          }}
        >
          <div
            className="flex flex-col items-center justify-center rounded-[16px] bg-[#012A4A] p-3"
            style={{
              backgroundImage:
                "radial-gradient(circle at center, rgba(0,0,0,0) 0%, rgba(0,0,0,0.7) 100%)",
              boxShadow: "0px 0px 20px 0px #0000004D",
            }}
          >
            <NewLogo />
            <div className="flex w-full flex-col items-center justify-center">
              <div className="mt-4 w-full self-start">
                <h1 className="text-[24px] font-semibold text-white ">
                  Verify OTP
                </h1>
                <h4 className="text-[14px] text-stone-300">
                  OTP sent to your Registered phone number.
                </h4>
                <h4
                  className="mb-7 cursor-pointer self-start text-xs font-medium text-[#18A5D6] underline "
                  onClick={(e) => {
                    setEmail("");
                    setPhoneNumber("");
                    setOriginalEmail("");
                    setOriginalPhoneNumber("");
                    setIsOtpSent(false);
                    setUserJWT(null);
                    setIsSendOtpLoading(false);
                    setMobile("");
                  }}
                >
                  Change {phoneNumber}?
                </h4>
                <h1 className="text-[14px] font-medium text-white">
                  Enter OTP
                </h1>
                <input
                  id="otp"
                  name="otp"
                  type="text"
                  onChange={(event) => setOTP(event.target.value)}
                  required
                  className="h-12 w-full appearance-none rounded-md border-none bg-[#07274b] px-3 py-2 text-white placeholder-gray-500 focus:z-10 focus:border-[#7FC241] focus:outline-none focus:ring-[#7FC241] sm:text-sm"
                />
              </div>
              <a
                className="mt-2 cursor-pointer self-start text-xs text-[14px] font-semibold text-white underline"
                onClick={(e) => {
                  setIsResendOtp(!isResendOtp);
                }}
              >
                Resend OTP
              </a>
              {isResendOtp && (
                <div className="mt-2 mb-2 flex w-full items-center justify-between gap-2">
                  <button
                    className="w-full cursor-pointer rounded bg-cn_green p-2 text-sm text-white hover:bg-green-400 disabled:bg-slate-400"
                    onClick={() => resendOTP("voice")}
                  >
                    OTP On Call
                  </button>
                  <button
                    className="w-full cursor-pointer rounded bg-cn_green p-2 text-sm text-white hover:bg-green-400 disabled:bg-slate-400"
                    onClick={() => resendOTP("text")}
                  >
                    OTP on SMS
                  </button>
                </div>
              )}

              <button
                disabled={isVerifyOtpLoading || OTP?.length === 0}
                className=" mt-4 h-12 w-full rounded-lg bg-[#7FC241] text-center text-[16px] font-semibold text-[#121212] disabled:opacity-50"
                onClick={(event) => verifyOTP()}
              >
                {isVerifyOtpLoading ? "Verifying..." : "Verify"}
              </button>
            </div>
          </div>
        </div>
      </Dialog>
    );
  } else {
    return (
      <div className="overflow-hidden">
        <Dialog
          open={isModalEnabled}
          onClose={() => setIsModalEnabled(!isModalEnabled)}
          as="div"
          style={{ zIndex: "9999" }}
          className="fixed inset-0 z-40 mx-auto my-auto flex flex-col text-white"
        >
          <Dialog.Overlay className="fixed inset-0 z-10 my-auto bg-black/60 backdrop-blur-[10px]" />
          <Dialog.Title />
          <Dialog.Description />
          <div
            className="bg-glass-effect relative z-[80] m-auto  w-[90%] max-w-xl rounded-[16px] p-[1px]"
            style={{
              backgroundImage: `linear-gradient(
  to right,
  rgba(255, 255, 255, 0.3) 0%,
  rgba(255, 255, 255, 1) 50%,
  rgba(255, 255, 255, 0.3) 100%
)`,
            }}
          >
            <div
              className="flex flex-col items-center justify-center rounded-[16px] bg-[#012A4A] p-3"
              style={{
                backgroundImage:
                  "radial-gradient(circle at center, rgba(0,0,0,0) 0%, rgba(0,0,0,0.7) 100%)",
                boxShadow: "0px 0px 20px 0px #0000004D",
              }}
            >
              <NewLogo />
              <div className="mt-4 flex w-full flex-col items-center justify-center ">
                <div className="mb-2 flex w-full flex-col self-start">
                  <h1 className="  text-[24px] font-semibold text-white">
                    Forgot Email/Password
                  </h1>
                  {/* <small className="mb-7 text-xs text-stone-500 ">
                        Enter your email address to send OTP to your registered number
                        to reset password
                      </small> */}

                  <div className="mt-4">
                    <label
                      htmlFor="email-address"
                      className="text-[14px] font-medium text-white"
                    >
                      Email
                    </label>
                    <input
                      id="email-address"
                      name="email"
                      type="email"
                      disabled={phoneNumber?.length > 0}
                      onChange={(event) => setEmail(event.target.value)}
                      required
                      placeholder="Email"
                      className="h-12 w-full appearance-none rounded-lg border-none bg-[#07274b] text-white placeholder-gray-500 focus:z-10 focus:outline-none  focus:ring-[#7FC241] disabled:bg-gray-400 sm:text-sm"
                    />
                    <div className="my-4 flex w-full items-center justify-center">
                      <div className="h-[1px] w-full flex-1 bg-white/20" />
                      <div className="mx-2 text-center text-[14px] text-white/50">
                        Or
                      </div>
                      <div className="h-[1px] w-full flex-1 bg-white/20" />
                    </div>
                    <label
                      htmlFor="email-address"
                      className="text-[14px] font-medium text-white"
                    >
                      Phone Number
                    </label>
                    <div className="flex gap-2">
                      <div className="w-fit">
                        <CountryCode25
                          selected={selectedCountry}
                          setSelected={setSelectedCountry}
                          disable={email?.length > 0}
                        />
                      </div>
                      <div className="mt-1 flex-1">
                        <input
                          id="phone-number"
                          name="phone"
                          type="tel"
                          disabled={email?.length > 0}
                          onChange={(event) =>
                            setPhoneNumber(event.target.value)
                          }
                          placeholder="Phone Number"
                          pattern="[0-9.]+"
                          required
                          className={`h-12 w-full appearance-none rounded-lg border-none bg-[#07274b] px-3   
                                      text-white placeholder:text-sm placeholder:font-normal placeholder:text-white/50 focus:z-10 focus:border-[#7FC241] focus:outline-none focus:ring-[#7FC241] disabled:bg-[#475a73] sm:text-sm`}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <button
                  disabled={
                    isSendOtpLoading ||
                    (email?.length === 0 && phoneNumber?.length === 0)
                  }
                  className={`mt-4 h-12 w-full rounded-lg bg-[#7FC241] text-center text-[16px] font-semibold text-[#121212] disabled:opacity-50`}
                  onClick={(event) => onSubmit()}
                >
                  {isSendOtpLoading ? "Sending..." : "Send OTP"}
                </button>
              </div>
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
};

export default PasswordResetModal;
